import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class SizeBtn extends Phaser.GameObjects.Container {

  static get SIZE_SELECT() {return 'SIZE_SELECT';}

  static selected = null;

  constructor (scene,sizeId,btnWidth) {
    super(scene);

    this.bgShape = null;
    this.sizeShape = null;
    this.sizeId = null;
    this.sizeBtnWidth = null;

    this.sizeId = sizeId;
    this.sizeBtnWidth = btnWidth;

    this.bgShape = this.scene.add.rectangle(0, 0, this.sizeBtnWidth, this.sizeBtnWidth).setOrigin(0)
      .setStrokeStyle(1, 0xffffff, 1);

    this.add(this.bgShape);

    let colorSize;
    switch (this.sizeId) {
      case 'small':
        colorSize = 10;
        break;
      case 'medium':
        colorSize = 16;
        break;
      case 'large':
        colorSize = 30;
        break;
    }
    this.sizeShape = this.scene.add.rectangle((this.sizeBtnWidth / 2) - (colorSize / 2),(this.sizeBtnWidth / 2) - (colorSize / 2),colorSize,colorSize, 0x403942, 1).setOrigin(0);
    this.add(this.sizeShape);

    ABCyaPhaser.Container.setContainerInteractive(this, false);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      if (SizeBtn.selected !== this) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this.scene);
        this.emit(SizeBtn.SIZE_SELECT, this.sizeId);
        this.setSelected(true);
      }
    });
  };

  setSelected(isSelected) {

    if (isSelected) {
      if (SizeBtn.selected !== null) SizeBtn.selected.setSelected(false);
      SizeBtn.selected = this;
    }
    const fillColor = isSelected ? 0x969696 : 0xC4C1C6;
    this.bgShape.setFillStyle(fillColor, 1);
  };
}
